<template>
  <div v-if="items.length">
    <carousel
      :items="1"
      :nav="false"
      :autoplay="true"
      :dots="true"
      :autoplayTimeout="8000"
      class="primary-slides"
    >
      <div
        class="item"
        v-for="(
          { img_desktop, img_mobile, title, link, target }, keyItem
        ) in items"
        :key="keyItem"
      >
        <a :href="link" v-if="link" :target="target ? '_blank' : ''">
          <img
            class="img-slide"
            :src="files + (xs ? img_mobile : img_desktop)"
            :alt="title"
          />
        </a>
        <img
          class="img-slide"
          v-else
          :src="files + (xs ? img_mobile : img_desktop)"
          :alt="title"
        />
      </div>
    </carousel>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel2";

const _config = {
  mod: "slides",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    carousel,
  },
};
</script>

<style lang="scss">
.primary-slides {
  .img-slide {
    aspect-ratio: 1920/680;
    object-fit: cover;
    object-position: center;
    @media (max-width: 600px) {
      aspect-ratio: 600/600;
    }
  }
  .owl-dots {
    bottom: 10px;
    margin-top: 0 !important;
    position: absolute;
    width: 100%;
    .owl-dot {
      span {
        background-color: #ffffff !important;
        margin: 6px !important;
      }
      &.active {
        span {
          background-color: var(--v-primary-base) !important;
          height: 12px;
          margin: 5px !important;
          width: 12px;
        }
      }
    }
  }
}
</style>
